import { FormikValues } from "formik"
import { FormikMultipleAutoComplete } from "../../../../../shared/components/forms/Formik"
import { StringKeyOf } from "../../../../../lib/lang"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { ShopsListResponse, ShopsQuery, fetchShopsList } from "../../shops/shopsApi"
import { Shop } from "../../shops/shopsTypes"

function transformData(data: ShopsListResponse) {
    return data.shops
}

export type ProductShopsOption = Shop

type FormikShopsFieldProps<Values extends FormikValues> = Readonly<{
    name: StringKeyOf<Values>
}>

export function FormikShopsField<Values extends FormikValues>({ name }: FormikShopsFieldProps<Values>) {
    const { merchantId } = useMerchant()

    const shops = useApiQuery(fetchShopsList, {
        queryName: ShopsQuery.LIST,
        dependencies: {
            merchantId,
        },
        select: transformData,
    })

    return (
        <LocalizedStrict id="product-create-shops-field-label">
            <FormikMultipleAutoComplete<Values, ProductShopsOption, ProductShopsOption>
                name={name}
                label="Shops"
                options={shops.data ?? []}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                areOptionsEqual={(x, y) => x.id === y.id}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option}
                fullWidth
            />
        </LocalizedStrict>
    )
}
